import {
	default as React,
	type ReactNode,
	createContext,
	useContext,
} from "react";
import { useComplexState } from "use-complex-state";
import { AssetReducer } from "../reducers/AssetReducer";

const AssetContext = createContext({
	state: AssetReducer.getInitialState(),
	actions: AssetReducer.actions,
});

export const useAssetContext = () => useContext(AssetContext);

export const AssetProvider = ({ children }: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: AssetReducer.getInitialState(),
		reducers: AssetReducer.caseReducers,
	});

	return (
		<AssetContext.Provider value={{ state, actions }}>
			{children}
		</AssetContext.Provider>
	);
};
